"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.dashboard.selectGroupHint': '选择群组以预览消息',
    'whatsapp.dashboard.statsStatus': '群组状态',
};
